/**
 * Modo embebido: una pantalla de RiskMann abierta dentro de la Capacitación gratuita, en un iframe
 * del mismo origen con `?embebido=1`. En ese modo la app se muestra sin su navegación (ver App.vue)
 * y, al guardar, la pantalla avisa a la página de la capacitación en vez de navegar a otra parte.
 *
 * Se calcula una sola vez al cargar la app: las navegaciones internas ($router.push, las
 * redirecciones del guard) pierden la consulta, pero el iframe sigue siendo el mismo.
 */
const EN_IFRAME = window.self !== window.top;
const PEDIDO = new URLSearchParams(window.location.search).get("embebido") === "1";
const EMBEBIDO = EN_IFRAME && PEDIDO;

/** Tipo del mensaje que recibe la página de la capacitación (ver PanelPaso.vue). */
export const TIPO_PASO_GUARDADO = "riskmann:capacitacion:paso-guardado";

export function esEmbebido() {
  return EMBEBIDO;
}

/**
 * Avisa a la Capacitación gratuita que la pantalla guardó. Solo habla con el mismo origen.
 * @param {string} paso - perfil, espacio, conductor, vehiculo, formato, inspeccion, informe o cita.
 * @param {object} [datos] - Detalle opcional (p. ej. el id de lo creado).
 * @returns {boolean} true si estaba embebida y avisó; false si la pantalla debe seguir su flujo normal.
 */
export function avisarALaCapacitacion(paso, datos = {}) {
  if (!EMBEBIDO) return false;
  window.parent.postMessage({ tipo: TIPO_PASO_GUARDADO, paso, ...datos }, window.location.origin);
  return true;
}
